import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Numeral from 'numeral';
import './addModel.css';
import axios from 'config/axios';
import env from 'config/env';


const LoginModal = props => {

  const [inputBarcode, setTextInputBarcode] = useState('');
  const [errors, SeterrorAdd] = useState<any>([]);
  const [inputTypeSelect, setTyeInputSelect] = useState('');
  const [inputControlSelect, setControlInputControl] = useState('');
  const [inputDepartmentSelect, setDepartmentInputDepartment] = useState('');
  const zero =Numeral("0").format('0.00');
  


  const [valueAmount, setValueAmount] = useState<string>(zero);

  const obj = {
    fldcontrol: inputControlSelect,
    fldtype: inputTypeSelect,
    fldbarcode: inputBarcode,
    flddept_no: inputDepartmentSelect,

    fldamount:  valueAmount=== "0.00" ? null:  valueAmount,
  };
  // console.log(obj);

  const checkTextInput = e => {
    e.preventDefault();
 
   
    // Check for the select TextInput
    if (inputTypeSelect === ""  && inputControlSelect === "" ) {
      // console.log("both");
  
       const errorsAdd = {
        fldcontrol:"Control Value Is Required!!",
        fldtype: "Type Value Is Required!!",
        fldbarcode:"",
        flddept_no:"",
        fldamount: "",
  
      };
      SeterrorAdd(errorsAdd);
     
    }
   else if (inputTypeSelect === "") {
      e.preventDefault();
      // console.log("type");
      
       const errorsAdd = {
        fldcontrol:"",
        fldtype: "Type Value Is Required!!",
        fldbarcode:"",
        flddept_no:"",
        
       fldamount: "",
  
    
     
      };
      SeterrorAdd(errorsAdd);
      

       
    }
   else if ( inputControlSelect === "") {
      e.preventDefault();
      // console.log("Control");
      
       const errorsAdd = {
        fldcontrol:"Control Value Is Required!",
        fldtype: "",
        fldbarcode:"",
        flddept_no:"",       
        fldamount: "",
  
    
     
      };
      SeterrorAdd(errorsAdd);
      

       
    }
    else{ apiCall(obj)}

    //  Checked Successfully
    
    
  
  };
  // console.log(errors,"add error show")

  //adding api
  const apiCall = async obj => {
    await axios({
      method: 'post',
      url: `${env.apiURL}/invoice`,
      data: obj,
    })
      .then(error => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Success',
          text: 'Updated! Successfully',
          confirmButtonColor: '#2778c4',
          //showConfirmButton: true,
          timer: 2000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch(error => {
        
        const errorsAdd = {
          fldcontrol:"",
          fldtype: error.errors?.fldtype,
          fldbarcode: error.errors?.fldbarcode,
          flddept_no: error.errors?.flddept_no,
          
         fldamount: error.errors?.fldamount
    ,
      
       
        };

        SeterrorAdd(errorsAdd);
        if (error.errors.fldcontrol[0] === "Control Already Exists With Same Type"){
          Swal.fire({
            icon: 'error',
            title: 'Failed!',
            text:"Control Already Exists With Same Type"
          });

        }else{
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text:"Please Enter Required Details!"
        });
      }
  

  
    
      
      });
  };

  // //adding api
  // const apiCall = async obj => {
    
    const resetStates = () => {
    
      props.close()
      setTextInputBarcode("");
      setTyeInputSelect("");
      setControlInputControl(""); 
      setDepartmentInputDepartment("");
      setValueAmount(zero);

     
  Object.keys(errors).forEach(function (item) {
    // console.log(item); // key
    // console.log(errors[item]);
    errors[item] = ""; // value
  });
      

  
    

  }
   
  return (
    <>
      <Modal
        size="lg"
        className="mw-50"
        show={props.show}
        cancel={props.close}
        aria-labelledby="contained-modal-title-vcenter"
        onHide={resetStates}
        centered>
        <Modal.Header>
          <div>
            <div>
              <Modal.Title id="contained-modal-title-vcenter">
                Add Rule
              </Modal.Title>
            </div>
          </div>
          <div className="d-flex">
            <div>
              <Button
                className="m-1"
                variant="secondary"
                // onClick={props.close}
                // onClick={ resetStates}
                onClick={() => {
                  resetStates()}}
                
                size="sm">
                Cancel
              </Button>
            </div>
            <div aria-disabled="true">
              <div>
                <Button
                  className="m-1"
                  variant="primary"
                  size="sm"
                  onClick={e => checkTextInput(e)}>
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoginModal;
